/**
 * Product Description Accordion
 * Converts headings into an accordion structure
 * Supports H2, strong, or known section title texts
 */
(function() {
  'use strict';

  var knownSectionTitles = [
    'İÇERİĞİNDEKİ BİTKİLER',
    'IÇERIGINDEKI BITKILER',
    'AÇIKLAMA',
    'ACIKLAMA',
    'SAĞLIK BEYANLARI',
    'SAGLIK BEYANLARI',
    'YASAL UYARILAR',
    'KULLANIM ŞEKLİ',
    'KULLANIM SEKLI',
    'İÇİNDEKİLER',
    'ICINDEKILERI',
    'UYARILAR',
    'ÖNERİLEN KULLANIM',
    'ONERILEN KULLANIM',
    'SAKLANIM KOŞULLARI',
    'SAKLAMA KOŞULLARI',
    'HERBAL INGREDIENTS',
    'DESCRIPTION',
    'HEALTH CLAIMS',
    'LEGAL WARNINGS',
    'HOW TO USE',
    'INGREDIENTS',
    'WARNINGS',
    'RECOMMENDED USE',
    'STORAGE CONDITIONS'
  ];

  function normalizeText(text) {
    return text.trim().toUpperCase()
      .replace(/İ/g, 'I')
      .replace(/Ğ/g, 'G')
      .replace(/Ü/g, 'U')
      .replace(/Ş/g, 'S')
      .replace(/Ö/g, 'O')
      .replace(/Ç/g, 'C');
  }

  function isSectionTitle(text) {
    var normalized = normalizeText(text);
    for (var i = 0; i < knownSectionTitles.length; i++) {
      var normalizedTitle = normalizeText(knownSectionTitles[i]);
      if (normalized === normalizedTitle || normalized.indexOf(normalizedTitle) !== -1) {
        return true;
      }
    }
    if (text === text.toUpperCase() && text.length > 5 && text.length < 50) {
      return true;
    }
    return false;
  }

  function findHeadingElements(container) {
    var headings = [];

    var h2Elements = container.querySelectorAll('h2');
    if (h2Elements.length > 0) {
      h2Elements.forEach(function(el) {
        headings.push({ element: el, title: el.textContent.trim(), type: 'h2' });
      });
      return headings;
    }

    var otherHeadings = container.querySelectorAll('h3, h4, h5, h6');
    if (otherHeadings.length > 0) {
      otherHeadings.forEach(function(el) {
        var text = el.textContent.trim();
        if (isSectionTitle(text)) {
          headings.push({ element: el, title: text, type: 'heading' });
        }
      });
      if (headings.length > 0) return headings;
    }

    var allElements = container.querySelectorAll('p, strong, b, span');

    allElements.forEach(function(el) {
      var text = el.textContent.trim();

      if (el.tagName === 'P') {
        var children = el.children;
        if (children.length === 1 && (children[0].tagName === 'STRONG' || children[0].tagName === 'B')) {
          var strongText = children[0].textContent.trim();
          if (isSectionTitle(strongText)) {
            headings.push({ element: el, title: strongText, type: 'p-strong' });
          }
        }
        else if (children.length >= 1) {
          var firstChild = children[0];
          if ((firstChild.tagName === 'STRONG' || firstChild.tagName === 'B') &&
              firstChild.textContent.trim() === text && isSectionTitle(text)) {
            headings.push({ element: el, title: text, type: 'p-strong' });
          }
        }
        else if (el.children.length === 0 && isSectionTitle(text)) {
          headings.push({ element: el, title: text, type: 'p-text' });
        }
      }
      else if ((el.tagName === 'STRONG' || el.tagName === 'B')) {
        var parent = el.parentElement;
        if (parent && parent.tagName === 'P' && parent.children.length === 1) {
          // Already captured above
        } else if (isSectionTitle(text)) {
          headings.push({ element: el, title: text, type: 'strong' });
        }
      }
      else if (el.tagName === 'SPAN') {
        var style = window.getComputedStyle(el);
        var isBold = style.fontWeight === 'bold' || parseInt(style.fontWeight) >= 600;
        if (isBold && isSectionTitle(text)) {
          headings.push({ element: el, title: text, type: 'span' });
        }
      }
    });

    return headings;
  }

  function initDescriptionAccordion() {
    var containers = document.querySelectorAll('.product-description-accordion__content, [data-description-accordion]');

    containers.forEach(function(container) {
      if (container.dataset.accordionInitialized) return;
      container.dataset.accordionInitialized = 'true';

      var headingData = findHeadingElements(container);
      if (headingData.length === 0) return;

      var accordionWrapper = document.createElement('div');
      accordionWrapper.className = 'product-description-accordions';

      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = container.innerHTML;

      var headingElements = [];
      headingData.forEach(function(h) {
        var selector = h.type === 'h2' ? 'h2' : (h.type === 'p-strong' || h.type === 'p-text' ? 'p' : 'strong, b');
        tempDiv.querySelectorAll(selector).forEach(function(el) {
          if (el.textContent.trim() === h.title || el.textContent.trim().indexOf(h.title) !== -1) {
            if (headingElements.indexOf(el) === -1) {
              headingElements.push(el);
            }
          }
        });
      });

      var beforeFirstHeading = document.createDocumentFragment();
      var foundFirstHeading = false;
      var sections = [];
      var currentSection = null;
      var remainingHeadings = headingData.slice();

      Array.from(tempDiv.childNodes).forEach(function(node) {
        var isHeading = false;
        var headingTitle = '';

        if (node.nodeType === 1) {
          var nodeText = node.textContent.trim();

          for (var i = 0; i < remainingHeadings.length; i++) {
            var h = remainingHeadings[i];
            var textMatch = nodeText === h.title ||
                (nodeText.indexOf(h.title) !== -1 && nodeText.length < h.title.length + 20);

            if (textMatch) {
              var typeMatch = false;

              if (h.type === 'h2' && node.tagName === 'H2') typeMatch = true;
              else if (h.type === 'heading' && /^H[3-6]$/.test(node.tagName)) typeMatch = true;
              else if ((h.type === 'p-strong' || h.type === 'p-text') && node.tagName === 'P') typeMatch = true;
              else if (h.type === 'strong' && (node.tagName === 'STRONG' || node.tagName === 'B')) typeMatch = true;
              else if (h.type === 'span' && node.tagName === 'SPAN') typeMatch = true;

              if (typeMatch) {
                isHeading = true;
                headingTitle = h.title;
                remainingHeadings.splice(i, 1);
                break;
              }
            }
          }
        }

        if (isHeading) {
          foundFirstHeading = true;
          currentSection = {
            title: headingTitle,
            content: document.createDocumentFragment()
          };
          sections.push(currentSection);
        } else if (currentSection) {
          currentSection.content.appendChild(node.cloneNode(true));
        } else if (!foundFirstHeading) {
          beforeFirstHeading.appendChild(node.cloneNode(true));
        }
      });

      sections.forEach(function(section, index) {
        var details = document.createElement('details');
        details.className = 'product-desc-accordion';

        if (index === 0) {
          details.setAttribute('open', '');
        }

        var summary = document.createElement('summary');
        summary.className = 'product-desc-accordion__summary';
        summary.innerHTML =
          '<span class="product-desc-accordion__title">' + section.title + '</span>' +
          '<span class="product-desc-accordion__icon">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</span>';

        var content = document.createElement('div');
        content.className = 'product-desc-accordion__content rte text-subtext';
        content.appendChild(section.content);

        details.appendChild(summary);
        details.appendChild(content);
        accordionWrapper.appendChild(details);
      });

      container.innerHTML = '';

      if (beforeFirstHeading.childNodes.length > 0) {
        var beforeContent = document.createElement('div');
        beforeContent.className = 'product-desc-before-accordion';
        beforeContent.appendChild(beforeFirstHeading);
        container.appendChild(beforeContent);
      }

      if (sections.length > 0) {
        container.appendChild(accordionWrapper);
      }
    });
  }

  window.initDescriptionAccordion = initDescriptionAccordion;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initDescriptionAccordion();
    });
  } else {
    initDescriptionAccordion();
  }

  document.addEventListener('shopify:section:load', function() {
    initDescriptionAccordion();
  });

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var accordionContainers = node.querySelectorAll ?
              node.querySelectorAll('.product-description-accordion__content, [data-description-accordion]') : [];
            if (accordionContainers.length > 0 ||
                (node.classList && (node.classList.contains('product-description-accordion__content') ||
                 node.hasAttribute && node.hasAttribute('data-description-accordion')))) {
              setTimeout(initDescriptionAccordion, 100);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
